<template>
  <v-container fluid class="ma-0 pa-0 d-flex justify-center">
    <v-container class="ma-0 pa-2">
      <EditAuftrag
        v-if="editAuftrag.id"
        :prop_kunden="JSON.parse(JSON.stringify(prop_kunden))"
        :prop_settings="JSON.parse(JSON.stringify(prop_settings))"
        :prop_kosten="JSON.parse(JSON.stringify(prop_kosten))"
        :prop_auftrag="editAuftrag"
        :prop_saveErgebnis="saveErgebnis"
        :prop_isSaving="isSaving"
        :prop_isSaving_editAuftrag="isSaving_editAuftrag"
        :prop_isSaving_delAuftrag="isSaving_delAuftrag"
        @close="editAuftrag = {}"
        @save="saveAuftrag($event);"
        @del="delAuftrag($event);"
      />
      <v-row>
        <v-col>
          <v-btn
            small color="primary"
            @click="addAuftrag(prop_addauftragKundennummer);"
            :loading="isSaving_addAuftrag"
            :disabled="isSaving"
            class="me-2"
          >
            <v-icon>mdi-plus-box</v-icon>
          </v-btn>
          <AuftraegeUebersicht
            :prop_auftraege="prop_auftraege"
            :prop_kosten="prop_kosten"
            :prop_settings="prop_settings"
          />
          <MassenEmailDialog class="ml-2" />
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="12" sm="4" class="py-0" align="center">
          <span>{{ nurOffeneZahlungen ? 'Aufträge & Verträge' : (vertraegeanzeigen ? 'Verträge' : 'Aufträge') }}</span>
          <v-btn
            class="ml-2" x-small
            :disabled="nurOffeneZahlungen"
            aria-label="Zwischen Aufträgen und Verträgen wechseln"
            @click="vertraegeanzeigen = !vertraegeanzeigen"
          >
            <v-icon small>mdi-repeat</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="4" class="py-0">
          <v-checkbox
            v-model="nuroffeneanzeigen"
            :disabled="nurOffeneZahlungen"
            label="Nur offene Aufträge anzeigen"
          />
        </v-col>
        <v-col cols="12" sm="4" class="py-0">
          <v-checkbox
            v-model="nurOffeneZahlungen"
            label="Nur offene Zahlungen"
          />
        </v-col>
        <v-col v-if="nurOffeneZahlungen" cols="12" class="pt-0 text-caption grey--text">
          Alle Aufträge und Verträge mit offenem Restbetrag, unabhängig vom Bearbeitungsstatus.
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-text-field
            clearable dense
            label="Suchen..."
            append-icon="mdi-magnify"
            v-model="search"
            :rules="[
              $store.state.main.inputValidationRules.name,
            ]"
            class="ma-0"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
        :headers="tabellenSpalten"
        :items="tabellenAuftraege"
        :custom-filter="sucheAuftrag"
        :search="search"
        :loading="loading"
        :items-per-page="50"
        :header-props="headerProps"
        :footer-props="footerProps"
        :no-data-text="nurOffeneZahlungen ? 'Keine offenen Zahlungen gefunden' : 'Keine Aufträge gefunden'"
        :no-results-text="nurOffeneZahlungen ? 'Keine offenen Zahlungen gefunden' : 'Keine Aufträge gefunden'"
        loading-text="Lade Daten... Bitte warten"
        mobile-breakpoint="850"
      >
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ pageStart }} - {{ pageStop }} von {{ itemsLength }}
        </template>
        <template v-slot:item.kundennummer="{ item }">
          {{ kundenName(item) }}
          <div class="text-caption grey--text">Kundennummer: {{ item.kundennummer }}</div>
        </template>
        <template v-slot:item.settlement.openAmountMinor="{ item }">
          <span class="warning--text font-weight-bold">{{ offenerBetrag(item) }}</span>
        </template>
        <template v-slot:item.titel="{ item }">
          <div
            class="primary--text"
            @click="editAuftrag = item"
            style="cursor:pointer;"
          >
            <b
              v-if="item.titel !== '' && item.typ === 'Vertrag'"
              :class="{
                'success--text': item.status <= 5,
                'error--text': item.status == 6,
                'warning--text': item.status == 7,
                'grey--text': item.status >= 8,
              }"
            >
              {{ item.titel }}
            </b>
            <b
              v-if="item.titel !== '' && item.typ === 'Auftrag'"
              :class="{
                'success--text': item.status <= 5,
                'error--text': item.status == 6,
                'grey--text': item.status >= 8,
              }"
            >
              {{ item.titel }}
            </b>
            <b v-if="item.titel === ''">
              --
            </b>
            <v-dialog
              v-if="
                item.leistungen.filter((o) => o.kosten > 0 && o.id_kosten <= 0).length > 0
              "
              v-model="dialog_infoKeineEchtenKosten[item.id]"
              width="500px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  x-small color="warning"
                  v-bind="attrs"
                  v-on="on"
                  class="mx-1"
                >!</v-chip>
              </template>
              <!-- <v-card>
                <v-card-title>asd</v-card-title>
                <v-card-text>asd</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    small text
                  >schließen</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    small text color="primary"
                  >OK</v-btn>
                </v-card-actions>
              </v-card> -->
              <v-card>
                <v-alert
                  border="bottom"
                  colored-border
                  type="warning"
                  elevation="2"
                  class="ma-0"
                >
                  Es gibt noch Leistungen mit Kosten,
                  die nicht mit einer Kostenposition verknüpft sind.
                  <v-divider class="my-2"></v-divider>
                  <div align="right"><v-btn
                    small text
                    @click="dialog_infoKeineEchtenKosten[item.id] = false"
                  >OK</v-btn></div>
                </v-alert>
              </v-card>
            </v-dialog>
            <div v-if="nurOffeneZahlungen" class="text-caption grey--text">
              Nummer: {{ item.auftragsnummer }}
            </div>
            <Zahlungsdeckung v-else :settlement="item.settlement" />
          </div>
          <div style="font-size:70%;" class="grey--text"
            v-if="item.time_lastUpdate > 0"
          >
            {{
              new Date(item.time_lastUpdate * 1000).toLocaleString('de-DE', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: 'numeric', minute: 'numeric',
              })
            }} Uhr
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <span
            v-if="
              item.typ === 'Auftrag'
              && prop_settings.auftragsstatus.filter((o) => o.nummer === item.status).length > 0
            "
          >
            <v-icon
              :class="{
                'success--text': item.status <= 5,
                'error--text': item.status == 6,
                'grey--text': item.status >= 8,
              }"
            >
              {{ prop_settings.auftragsstatus.filter((o) => o.nummer === item.status)[0].icon }}
            </v-icon><br>
          </span>
          <span
            v-if="
              item.typ === 'Vertrag'
              && prop_settings.vertragsstatus.filter((o) => o.nummer === item.status).length > 0
            "
          >
            <v-icon
              :class="{
                'success--text': item.status <= 5,
                'error--text': item.status == 6,
                'warning--text': item.status == 7,
                'grey--text': item.status >= 8,
              }"
            >
              {{ prop_settings.vertragsstatus.filter((o) => o.nummer === item.status)[0].icon }}
            </v-icon><br>
          </span>
        </template>
        <template v-slot:item.umsatz="{ item }">
          <div align="left">
            {{
              item.umsatz.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
            }}
          </div>
        </template>
        <template v-slot:item.kosten="{ item }">
          <div align="left">
            {{
              (item.kosten - item.kosten_mwst)
                .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
            }}
          </div>
        </template>
        <template v-slot:item.gewinn="{ item }">
          <div align="left">
            {{
              (item.gewinn + item.kosten_mwst)
                .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
            }}
          </div>
        </template>
        <template v-slot:item.vertrag_zahlungJaehrlich="{ item }">
          {{ item.vertrag_zahlungJaehrlich }}
          <div align="left"
            v-if="item.typ === 'Vertrag'"
          >
            <span v-if="item.vertrag_zahlungJaehrlich === 1">jährlich</span>
            <span v-if="item.vertrag_zahlungJaehrlich === 0">monatlich</span>
          </div>
        </template>
        <template v-slot:item.vertrag_ende="{ item }">
          <div align="left"
            v-if="item.typ === 'Vertrag'"
          >{{ item.dateVertrag_ende }}</div>
        </template>
        <template v-slot:item.aktionen="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="primary"
                v-bind="attrs"
                v-on="on"
                :loading="isSaving_duplicateAuftrag === item.id"
                :disabled="isSaving"
                @click.stop="duplicateAuftrag(item)"
              >
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>{{ item.typ }} duplizieren (ohne Dokumente)</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
// import $ from 'jquery';
import EditAuftrag from '@/components/Funktionen/400/410-Kunden/EditAuftrag.vue';
import Zahlungsdeckung from './Zahlungsdeckung.vue';
import AuftraegeUebersicht from '@/components/Funktionen/400/410-Kunden/AuftraegeUebersicht.vue';
import MassenEmailDialog from '@/components/Funktionen/400/410-Kunden/MassenEmailDialog.vue';

export default {
  components: {
    EditAuftrag,
    Zahlungsdeckung,
    AuftraegeUebersicht,
    MassenEmailDialog,
  },
  props: {
    prop_addauftragKundennummer: {
      type: String,
      default: '0',
    },
    prop_settings: {
      type: Object,
      default() { return {}; },
    },
    prop_auftraege: {
      type: Array,
      default() { return []; },
    },
    prop_kunden: {
      type: Array,
      default() { return []; },
    },
    prop_kosten: {
      type: Array,
      default() { return []; },
    },
    prop_nuroffeneanzeigen: {
      type: Boolean,
      default: true,
    },
    prop_nurvertraegeanzeigen: {
      type: Boolean,
      default: false,
    },
    prop_activeSaveRequest: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    dialog_infoKeineEchtenKosten: {},
    dialog_infoRechnungOffen: {},
    dialog_infoRechnungOffenMinus: {},
    nuroffeneanzeigen: true,
    nurOffeneZahlungen: false,
    nurvertraegeanzeigen: false,
    vertraegeanzeigen: false,
    editAuftrag: {},
    saveErgebnis: null,
    xLoaded: {
      auftraege: {},
    },
    xChanged: {},
    save: {
      settings: {},
      auftraege: [],
    },
    loading: false,
    search: '',
    headers: [
      // { text: 'Auftrag', value: 'auftragsnummer', width: '150px' },
      { text: 'Status', value: 'status' },
      { text: 'Titel', value: 'titel', width: '200px' },
      { text: 'Umsatz', value: 'umsatz' },
      { text: 'Kosten', value: 'kosten' },
      { text: 'Gewinn', value: 'gewinn' },
      { text: 'Vertrag', value: 'vertrag_zahlungJaehrlich' },
      { text: 'Verlängerung', value: 'vertrag_ende' },
      { text: 'Aktionen', value: 'aktionen', width: '90px', sortable: false },
    ],
    headerProps: {
      sortByText: 'Sortiere nach',
    },
    footerProps: {
      itemsPerPageText: 'Elemente pro Seite:',
      itemsPerPageOptions: [5, 10, 20, 50, -1],
      itemsPerPageAllText: 'Alle',
    },
  }),
  computed: {
    kundenNamen() {
      return this.prop_kunden.reduce((namen, kunde) => {
        namen[String(kunde.kundennummer)] = kunde.ident || kunde.firma;
        return namen;
      }, {});
    },
    tabellenSpalten() {
      if (!this.nurOffeneZahlungen) return this.headers;
      return [
        { text: 'Kunde', value: 'kundennummer', sortable: false },
        { text: 'Auftrag / Vertrag', value: 'titel' },
        { text: 'Art', value: 'typ' },
        { text: 'Offener Betrag', value: 'settlement.openAmountMinor', sort: (a, b) => Number(a) - Number(b) },
        { text: 'Aktionen', value: 'aktionen', width: '90px', sortable: false },
      ];
    },
    tabellenAuftraege() {
      return this.save.auftraege.filter((auftrag) => {
        if (this.nurOffeneZahlungen) {
          // Derselbe Belegsaldo wie im Dialog. Auch beendete Auftraege koennen
          // noch einen Rest haben; fehlende Daten gelten nicht als offene Zahlung.
          const rest = Number(auftrag.settlement && auftrag.settlement.openAmountMinor);
          return Number.isFinite(rest) && rest > 0;
        }
        return (!this.nuroffeneanzeigen || Number(auftrag.status) <= 6)
          && (!this.nurvertraegeanzeigen || auftrag.typ === 'Vertrag')
          && auftrag.typ === (this.vertraegeanzeigen ? 'Vertrag' : 'Auftrag');
      }).sort((a, b) => {
        if (this.nurOffeneZahlungen) {
          const differenz = Number(b.settlement.openAmountMinor) - Number(a.settlement.openAmountMinor);
          if (differenz) return differenz;
        }
        return Number(b.time_lastUpdate) - Number(a.time_lastUpdate) || Number(a.id) - Number(b.id);
      });
    },
    isSaving() {
      return Boolean(this.prop_activeSaveRequest);
    },
    isSaving_editAuftrag() {
      return this.prop_activeSaveRequest
        ? this.prop_activeSaveRequest.type === 'saveAuftrag'
        : false;
    },
    isSaving_delAuftrag() {
      return this.prop_activeSaveRequest
        ? this.prop_activeSaveRequest.type === 'delAuftrag'
        : false;
    },
    isSaving_addAuftrag() {
      return this.prop_activeSaveRequest
        ? this.prop_activeSaveRequest.type === 'addAuftrag'
        : false;
    },
    isSaving_duplicateAuftrag() {
      return this.prop_activeSaveRequest
        && this.prop_activeSaveRequest.type === 'duplicateAuftrag'
        ? this.prop_activeSaveRequest.targetId
        : null;
    },
  },
  watch: {
    prop_settings: {
      handler() {
        this.datenLaden();
      },
      deep: true,
    },
    prop_auftraege: {
      handler() {
        this.datenLaden();
      },
      deep: true,
    },
  },
  methods: {
    kundenName(auftrag) {
      return this.kundenNamen[String(auftrag.kundennummer)] || `Kunde ${auftrag.kundennummer}`;
    },
    sucheAuftrag(wert, suche, auftrag) {
      const text = [wert, this.kundenName(auftrag), auftrag.kundennummer, auftrag.auftragsnummer]
        .filter((teil) => teil !== null && teil !== undefined).join(' ').toLocaleLowerCase('de-DE');
      return text.includes(String(suche || '').trim().toLocaleLowerCase('de-DE'));
    },
    offenerBetrag(auftrag) {
      return (Number(auftrag.settlement.openAmountMinor) / 100)
        .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    },
    addAuftrag(kundennummer) {
      this.$emit('tryGetOrSave', { type: 'addAuftrag', data: { kundennummer } });
    },
    duplicateAuftrag(auftrag) {
      this.$emit('tryGetOrSave', { type: 'duplicateAuftrag', data: { id: auftrag.id } });
    },
    saveAuftrag(data) {
      this.$emit('tryGetOrSave', { type: 'saveAuftrag', data });
    },
    delAuftrag(data) {
      this.$emit('tryGetOrSave', { type: 'delAuftrag', data });
    },
    datenLaden() {
      /*
        Wenn neue Daten übergeben wurden,
        prüfe ob diese sich von den zuletzt geladenen unterscheiden.
        Wenn ja, überschreibe die aktuellen Daten mit den neu übergebenen Daten.
      */
      let anythingUpdated = false;
      if (JSON.stringify(this.prop_settings) !== JSON.stringify(this.xLoaded.settings)) {
        this.save.settings = JSON.parse(JSON.stringify(this.prop_settings));
        this.xLoaded.settings = JSON.parse(JSON.stringify(this.prop_settings));
        anythingUpdated = true;
      }
      this.prop_auftraege.forEach((k) => {
        if (!this.save.auftraege.filter((o) => o.id === k.id).length > 0) {
          this.save.auftraege.push(k);
          this.xLoaded.auftraege[k.id] = JSON.stringify(k);
          anythingUpdated = true;
        } else if (
          JSON.stringify(k) !== this.xLoaded.auftraege[k.id]
        ) {
          this.save.auftraege.splice(
            this.save.auftraege.indexOf(this.save.auftraege.filter((o) => o.id === k.id)[0]),
            1,
          );
          this.save.auftraege.push(k);
          this.xLoaded.auftraege[k.id] = JSON.stringify(k);
          anythingUpdated = true;
        }
      });
      this.save.auftraege.forEach((k) => {
        if (!this.prop_auftraege.filter((o) => o.id === k.id).length > 0) {
          this.save.auftraege.splice(
            this.save.auftraege.indexOf(this.save.auftraege.filter((o) => o.id === k.id)[0]),
            1,
          );
          anythingUpdated = true;
        }
      });
      if (anythingUpdated) {
        if (this.save.settings.lastAddedAuftrag) {
          if (
            this.save.auftraege
              .filter((o) => o.id === this.save.settings.lastAddedAuftrag).length > 0
          ) {
            [this.editAuftrag] = this.save.auftraege
              .filter((o) => o.id === this.save.settings.lastAddedAuftrag);
          }
        }
        if (this.save.settings.lastEditedAuftrag === this.editAuftrag.id) {
          this.saveErgebnis = this.save.settings.lastEditedAuftragErgebnis || null;
          // this.editAuftrag = {};
          if (this.prop_settings.lastEditedAuftrag) {
            this.prop_settings.lastEditedLeistungenNeuKosten.forEach((k) => {
              if (this.editAuftrag.leistungen.filter((o) => o.pos === k.pos).length > 0) {
                this.editAuftrag.leistungen
                  .filter((o) => o.pos === k.pos)[0].id_kosten = k.id_kosten;
                this.editAuftrag.leistungen
                  .filter((o) => o.pos === k.pos)[0].tabs_neuKosten = 0;
                this.editAuftrag.leistungen
                  .filter((o) => o.pos === k.pos)[0].betrag = k.betrag;
              }
            });
            //  .filter((o) => o.id === this.prop_settings.lastEditedAuftrag));
          }
          this.prop_settings.lastEditedAuftrag = 0;
        }
        if (this.save.settings.lastDeletedAuftrag) {
          this.editAuftrag = {};
        }
        this.save.auftraege.sort((a, b) => {
          if (a.auftragsnummer > b.auftragsnummer) {
            return -1;
          }
          if (a.auftragsnummer < b.auftragsnummer) {
            return 1;
          }
          return 0;
        });
        this.save.auftraege.sort((a, b) => {
          if (a.status > b.status) {
            return 1;
          }
          if (a.status < b.status) {
            return -1;
          }
          return 0;
        });
      }
    },
  },
  created() {
    this.nuroffeneanzeigen = this.prop_nuroffeneanzeigen;
    this.nurvertraegeanzeigen = this.prop_nurvertraegeanzeigen;
    this.datenLaden();
    if (this.$router.history.current.query.a) {
      if (this.prop_auftraege
        .filter((a) => a.id === parseInt(this.$router.history.current.query.a, 10)).length > 0) {
        [this.editAuftrag] = this.prop_auftraege
          .filter((a) => a.id === parseInt(this.$router.history.current.query.a, 10));
        this.$router.push(this.$router.history.current.path);
      }
    }
  },
};
</script>
